module.exports = __webpack_public_path__ + "img/24.32a6cb9c.png";